export default __webpack_public_path__ + "static/media/move_rollover.3ee2885a.PNG";